module.exports = __webpack_public_path__ + "static/img/adhd-rs5-cn-cover.8fa6785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/adhd-rs5-cn-cover.png
// module id = D1K5
// module chunks = 13